import { Link } from "react-router-dom";
import { useAuth } from "../../../auth/AuthContext.js";
import { TelegramAutomationPanel } from "./TelegramAutomation.js";
import { TelegramPublicationsList } from "./TelegramPublish.js";

/** FIX-067: every Telegram post (manual and automatic) with its link. Owner only (the server enforces the same). */
export function TelegramChannelsPage({ tenantId }: { readonly tenantId: string }) {
  const { user, csrfToken } = useAuth();
  if (user?.isPlatformOwner !== true) {
    return (
      <div className="card">
        <p className="muted">Not available.</p>
      </div>
    );
  }
  return (
    <div className="grid" style={{ gap: 12 }} data-testid="telegram-channels-page">
      <div>
        <Link to="..">← Back</Link>
      </div>
      <TelegramAutomationPanel tenantId={tenantId} csrfToken={csrfToken} />
      <TelegramPublicationsList tenantId={tenantId} trigger="auto" title="Automatic posts" />
      <TelegramPublicationsList tenantId={tenantId} />
    </div>
  );
}
